// Blog-Artikel für Dickies-Campus · /blog
// body: Array aus Blöcken { type: 'p' | 'h2', text }

export const BLOG_POSTS = [
  {
    slug: 'pflegeassistenz-ohne-erfahrung',
    title: 'Pflegeassistenz ohne Erfahrung: Was ist möglich?',
    metaDescription:
      'Ohne Berufserfahrung in die Pflege: Die Ambulante Pflegeassistenz umfasst 300 Unterrichtseinheiten in ca. 9 Wochen, 100 % online live – Bildungsgutschein möglich.',
    datePublished: '2026-10-19',
    dateModified: '2026-10-19',
    teaser:
      'Du willst in die Pflege, hast aber noch nie in dem Bereich gearbeitet? Die Ambulante Pflegeassistenz ist ein guter Einstieg für Menschen mit wenig oder keiner Berufserfahrung.',
    relatedCourseSlug: 'ambulanter-pflegeassistent',
    body: [
      {
        type: 'p',
        text: 'Du willst in die Pflege, hast aber noch nie in dem Bereich gearbeitet? Dann ist die Ambulante Pflegeassistenz ein guter Einstieg. Sie ist für Menschen gedacht, die wenig oder keine Berufserfahrung haben.',
      },
      { type: 'h2', text: 'Wie lange dauert die Weiterbildung?' },
      {
        type: 'p',
        text: 'Die Weiterbildung umfasst 300 Unterrichtseinheiten und dauert etwa 9 Wochen. Du lernst 100 % online im Live-Unterricht per Zoom, Start ist jeden Montag. Inhalt sind die Grundlagen der Pflege und die Behandlungspflege (LG1 und LG2).',
      },
      { type: 'h2', text: 'Was kostet sie und gibt es eine Förderung?' },
      {
        type: 'p',
        text: 'Die Kosten betragen 2.390 €. Du kannst in 3, 6 oder 12 Raten ohne Aufschlag zahlen, ab 199,16 € im Monat. Für diese Weiterbildung und für die Pflegeassistenz nach LG1 und LG2 ist ein Bildungsgutschein möglich.',
      },
      { type: 'h2', text: 'Unsicher, ob der Kurs zu dir passt?' },
      {
        type: 'p',
        text: 'Frag uns einfach, die Beratung ist kostenlos.',
      },
    ],
  },
  {
    slug: 'lg1-lg2-was-bedeutet-das',
    title: 'Was bedeutet LG1 und LG2 in der ambulanten Pflege?',
    metaDescription:
      'LG1 und LG2 sind Leistungsgruppen der Behandlungspflege in der ambulanten Pflege. Überblick über die Kerninhalte – plus passende Weiterbildung (208 UE, ca. 6,5 Wochen).',
    datePublished: '2026-10-19',
    dateModified: '2026-10-19',
    teaser:
      'Wer in der ambulanten Pflege arbeitet, hört schnell LG1 und LG2. Gemeint sind Leistungsgruppen der Behandlungspflege – hier der Überblick über die Kerninhalte.',
    relatedCourseSlug: 'pflegeassistent-lg1-lg2',
    body: [
      { type: 'p', text: 'Wer in der ambulanten Pflege arbeitet, hört schnell LG1 und LG2. Gemeint sind Leistungsgruppen der Behandlungspflege.' },
      { type: 'h2', text: 'Was gehört zu LG1?' },
      { type: 'p', text: 'Zu den Kerninhalten der Leistungsgruppe 1 gehören:' },
      { type: 'ul', items: [
        'Medikamentengabe (Richten und Verabreichen von verordneten Medikamenten)',
        'Blutzuckermessung (Durchführung und Protokollierung der Werte)',
        'Subkutane Injektionen (Spritzen in das Unterhautfettgewebe, zum Beispiel Insulin oder Thrombosespritzen)',
        'Blutdruckmessung (Messen und Dokumentieren der Vitalwerte)',
        'Kompressionsstrümpfe (An- und Ausziehen ab Kompressionsklasse 1 oder Anlegen von Kompressionsverbänden)',
      ] },
      { type: 'h2', text: 'Was gehört zu LG2?' },
      { type: 'p', text: 'Zu den Kerninhalten der Leistungsgruppe 2 gehören in der Regel:' },
      { type: 'ul', items: [
        'Wundversorgung (Dekubitus bis Grad 2)',
        'Katheter- und Sondenpflege (suprapubische Blasenkatheter SPK, PEG-Magensonden inkl. Nahrungsgabe)',
        'Ausscheidungshilfe (Klysmen, Klistieren, Einläufe)',
        'Flüssigkeitsbilanzierung (Dokumentation und Überwachung von Aufnahme und Abgabe)',
        'Spezielle lokale Therapien (medizinische Einreibungen, dermatologische Bäder)',
      ] },
      { type: 'h2', text: 'Unsere Weiterbildung' },
      { type: 'p', text: 'In der Weiterbildung Pflegeassistenz nach LG1 und LG2 lernst du diese Inhalte. Sie dauert 208 Unterrichtseinheiten, etwa 6,5 Wochen, und kostet 1.499 €, oder in 3, 6 oder 12 Raten ab 124,91 € im Monat. Ein Bildungsgutschein ist möglich. Voraussetzung ist eine Pflege-Grundqualifikation.' },
    ],
  },
  {
    slug: 'bildungsgutschein-pflege-weiterbildung',
    title: 'Weiterbildung mit Bildungsgutschein: So läuft es ab',
    metaDescription:
      'Bildungsgutschein der Agentur für Arbeit oder des Jobcenters: Für welche Pflege-Weiterbildungen er möglich ist und wie du ihn bekommst – kostenlose Beratung.',
    datePublished: '2026-10-19',
    dateModified: '2026-10-19',
    teaser:
      'Ein Bildungsgutschein ist eine Förderung der Agentur für Arbeit oder des Jobcenters. Für welche Weiterbildungen er bei uns möglich ist – und wie du ihn bekommst.',
    relatedCourseSlug: 'ambulanter-pflegeassistent',
    body: [
      { type: 'p', text: 'Ein Bildungsgutschein ist eine Förderung der Agentur für Arbeit oder des Jobcenters. Bei uns ist er möglich für die Ambulante Pflegeassistenz, die Pflegeassistenz nach LG1 und LG2 sowie für die Pflegehilfskraft und Betreuungsassistenz. Die Pflegehilfskraft und Betreuungsassistenz gibt es nur mit Bildungsgutschein. Für den Wundexperten und die Pflegedienstleitung gibt es keinen Bildungsgutschein, diese Kurse buchst du direkt oder in Raten (3, 6 oder 12 Raten, ohne Aufschlag). Wie du den Gutschein bekommst, klären wir in der kostenlosen Beratung gemeinsam. Wir prüfen, welche Förderung zu dir passt.' },
    ],
  },
  {
    slug: 'pdl-weiterbildung-abgebrochen',
    title: 'PDL-Weiterbildung abgebrochen: So machst du weiter',
    metaDescription:
      'PDL-Weiterbildung abgebrochen? Bereits absolvierte Teile können angerechnet werden. 720 Unterrichtseinheiten, 4.690 € oder in Raten, Start jeden Montag.',
    datePublished: '2026-10-19',
    dateModified: '2026-10-19',
    teaser:
      'Du hast die Weiterbildung zur Pflegedienstleitung begonnen und musstest sie abbrechen? Sprich mit uns – wir rechnen bereits absolvierte Teile an.',
    relatedCourseSlug: 'pdl',
    body: [
      { type: 'p', text: 'Du hast die Weiterbildung zur Pflegedienstleitung begonnen und musstest sie abbrechen, zum Beispiel wegen eines Jobwechsels, der Insolvenz deines Arbeitgebers oder aus privaten Gründen? Sprich mit uns. Wir schauen gemeinsam, wo du stehst, und rechnen bereits absolvierte Teile an. Je nach Vorerfahrung geht es schneller als die üblichen 36 Wochen. Die PDL umfasst 720 Unterrichtseinheiten und kostet 4.690 €, oder in 3, 6 oder 12 Raten ab 390,83 € im Monat. Ein Bildungsgutschein ist nicht möglich. Die Weiterbildung richtet sich an Pflegefachkräfte. Start ist jeden Montag.' },
    ],
  },
  {
    slug: 'quereinstieg-pflege-wo-anfangen',
    title: 'Quereinstieg in die Pflege: Wo fängt man an?',
    metaDescription:
      'Quereinstieg in die Pflege ohne Ausbildung: Ambulante Pflegeassistenz (ca. 9 Wochen) oder Pflegehilfskraft und Betreuungsassistenz (ca. 14 Wochen) – was passt zu dir?',
    datePublished: '2026-10-19',
    dateModified: '2026-10-19',
    teaser:
      'Du willst in die Pflege wechseln, hast aber keine Ausbildung? Zwei Einstiege im Vergleich: Ambulante Pflegeassistenz und Pflegehilfskraft und Betreuungsassistenz.',
    relatedCourseSlug: 'ambulanter-pflegeassistent',
    body: [
      { type: 'p', text: 'Du willst in die Pflege wechseln, hast aber keine Ausbildung? Die Ambulante Pflegeassistenz ist für Menschen mit wenig oder keiner Berufserfahrung gedacht: 300 Unterrichtseinheiten, etwa 9 Wochen, 2.390 €, mit Bildungsgutschein möglich. Die Pflegehilfskraft und Betreuungsassistenz ist ein breiterer Einstieg in Pflege und Betreuung: 429 Unterrichtseinheiten inklusive 40 Stunden Praktikum, etwa 14 Wochen, 3.490 €, nur mit Bildungsgutschein. Welche Weiterbildung zu dir passt, klären wir in der kostenlosen Beratung.' },
    ],
  },
  {
    slug: 'wer-darf-was-atlas',
    title: 'Wer darf was in der Pflege? Der kostenlose Atlas',
    metaDescription:
      'Wer darf was in der Pflege? Der kostenlose Atlas gibt den Überblick: 251 Seiten, 17-seitige Vorschau per E-Mail, Vollversion nach Anmeldung im Campus.',
    datePublished: '2026-10-19',
    dateModified: '2026-10-19',
    teaser:
      'In der Pflege stellt sich jeden Tag dieselbe Frage: Wer darf was? Unser Atlas gibt dir dazu einen Überblick – 251 Seiten stark und kostenlos.',
    relatedBox: {
      kicker: 'Kostenloser Atlas',
      title: 'Wer darf was? Der Atlas für die Pflege',
      subtitle: '251 Seiten · kostenlos',
      to: '/atlas-wer-darf-was',
      cta: 'Zum kostenlosen Atlas',
    },
    body: [
      { type: 'p', text: 'In der Pflege stellt sich jeden Tag dieselbe Frage: Wer darf was? Unser Atlas Wer darf was gibt dir dazu einen Überblick, 251 Seiten stark und kostenlos. Du bekommst zuerst eine 17-seitige Vorschau per E-Mail. Die Vollversion mit 251 Seiten erhältst du nach deiner Anmeldung im Campus.', },
      { type: 'p', text: 'Den Atlas gibt es zusammen mit weiteren kostenlosen Leitfäden und Magazinen auf unserer Seite.', linkText: 'auf unserer Seite', linkTo: '/leitfaeden' },
    ],
  },
];

export const getBlogPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);

export const formatBlogDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
